/** @format */

const isSSR = typeof window === "undefined";

export default isSSR;
export { isSSR };
